<template>
  <section class="section full-height">
    <admin-section-header icon="bell" title="Configuracion" />
    <SectionUnderDevelopment/>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import TextIconTile from '@/components/admin/dasboard/TextIconTile.vue'
import SectionUnderDevelopment from '@/components/common/SectionUnderDevelopment.vue'
export default {
  name: 'Configuration',
  components: { AdminSectionHeader, TextIconTile, SectionUnderDevelopment },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Configuration'],
      title: 'Configuration'
    })
  }
}
</script>

<style scoped></style>
